import { render, staticRenderFns } from "./text-response.vue?vue&type=template&id=43abfd95&scoped=true&"
import script from "./text-response.vue?vue&type=script&lang=js&"
export * from "./text-response.vue?vue&type=script&lang=js&"
import style0 from "./text-response.vue?vue&type=style&index=0&id=43abfd95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43abfd95",
  null
  
)

component.options.__file = "text-response.vue"
export default component.exports